module.exports = __webpack_public_path__ + "static/media/logo.f2fa8c84.png";